module.exports = __webpack_public_path__ + "img/AI+IoT闭环icon.079c48d4.png";